import { Button, Tooltip } from '@fluentui/react-components'
import { ArrowSyncRegular } from '@fluentui/react-icons'
import { useQueryClient } from '@tanstack/react-query'
import styles from '../../../Buttons/ProjectEconomyHeaderButtons/ProjectEconomyButton.module.css'
import useProjectId from '../../customHooks/useProjectId'

export const RefreshCacheButton = () => {
  const queryClient = useQueryClient()
  const projectId = useProjectId()

  const handleRefresh = () => {
    queryClient.invalidateQueries({
      predicate: (query) =>
        Array.isArray(query.queryKey) && query.queryKey.includes(projectId),
    })
  }

  return (
    <>
      <Tooltip content="Uppdatera cachen" relationship="label">
        <Button
          className={styles.projectEconomyButton}
          icon={<ArrowSyncRegular />}
          appearance="subtle"
          onClick={handleRefresh}
        />
      </Tooltip>
    </>
  )
}
